type Theme = 'light' | 'dark';

let themePreview: Theme | null = null;

function getSystemTheme(): Theme {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyTheme() {
  document.body.classList.remove('light', 'dark');
  document.body.classList.add((import.meta.env.DEV && themePreview) || getSystemTheme());
}

export function setThemePreview(theme: Theme | null) {
  if (!import.meta.env.DEV) return;

  themePreview = theme;
  applyTheme();
}

export function initializeTheme() {
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  applyTheme();
  mediaQuery.addEventListener('change', applyTheme);
}
